module.exports = __webpack_public_path__ + "static/media/fruit-icon-cherry.bfeedb49.jpg";